/* global axios */

import ApiClient from './ApiClient';

class InboxDashboardAppAutomationsAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/dashboard_app_automations`);
  }

  update(inboxId, dashboardAppId, automation) {
    return axios.put(
      `${this.url}/${inboxId}/dashboard_app_automations/${dashboardAppId}`,
      { automation }
    );
  }
}

export default new InboxDashboardAppAutomationsAPI();
